import Avatar1 from '../../assets/avatar1.jpg'
import Avatar2 from '../../assets/avatar2.jpg'
import Avatar3 from '../../assets/avatar3.jpg'
import Avatar4 from '../../assets/avatar4.png'
import Avatar5 from '../../assets/avatar5.png'
import Avatar6 from '../../assets/avatar6.jpg'
import Avatar7 from '../../assets/avatar7.png'


const data = [
        {
        id: 1,
        quote: "It's truly amazing how you did exactly what I want with the little information I gave. You'll be my go-to developer from today. Highly recommend!",
        avatar: Avatar1,
        name: 'Mohamed Aouina',
        profession: 'BI Analyst.'
        },
        {
        id: 2,
        quote: "Good job, Mohamed! Right on time! I really like how the project turned out, and my customers like it as well. It was fun collaborating with you.",
        avatar: Avatar2,
        name: 'Anas Gara',
        profession: 'Full Stack Developer'
        },
        {
        id: 3,
        quote: "Impressive work, buddy. Highly recommend!",
        avatar: Avatar3,
        name: 'Mohamed Chattely',
        profession: 'Graphic Designer'
        },
        {
        id: 4,
        quote: "Wow. You finished earlier than you said. Everything's modern and beautifully done to the T. Great profession!",
        avatar: Avatar4,
        name: 'Fedi Ben Salha',
        profession: 'Pilot'
        },
        {
        id: 5,
        quote: "I like how the app turned out. You are incredible, Mohamed.",
        avatar: Avatar5,
        name: 'Yassine Kharoubi',
        profession: 'comptable'
        },
        {
        id: 6,
        quote: "Best developer in the world!",
        avatar: Avatar6,
        name: 'Youssef Ben Jerbania',
        profession: 'Brand Influencer'
        },
        {
        id: 7,
        quote: "Keep doing great stuff, dear! Nicely executed!",
        avatar: Avatar7,
        name: 'Amir Zanned',
        profession: 'Big Data Analyst'
        }
    ]



    export default data